const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getListClassroom({ commit }, { classId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/next-class/classroom/${classId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListStudent({ commit }, { classId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/next-class/classroom/${classId}/students`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCouse({ commit }, { classroomId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/next-class/classroom/${classroomId}/courses`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCouseAll({ commit }, classroomId) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/next-class/classroom/${classroomId}/all-courses`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  addCourse({ commit }, payload) {
    return window.axios.put(`/api/next-class/classroom/${payload.classroomId}/course`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  create({ commit }, payload) {
    return window.axios.put(`/api/next-class/classroom/${payload.classIdURL}`, payload);
  }
};

export default { namespaced, state, getters, mutations, actions };
